<template>
  <div class="place-image-gallery">
    <TitleBar :text="$t('PlaceImageGallery.topic')" :showIconButton="false" @clickCloseButton="clickCloseButton" />
    <div class="backdrop" v-show="isShowDeleteConfirm || isDeleting">
      <div class="loading-animation" v-if="isDeleting"></div>
      <div class="delete-confirm-container" v-if="isShowDeleteConfirm">
        <div class="delete-confirm">
          <div class="body">
            <div class="text">{{ $t('PlaceImageGallery.deleteConfirmMessage') }}</div>
            <div class="button-container">
              <button class="outline" @click="clickDelete">{{ $t('PlaceImageGallery.ok') }}</button>
              <button @click="isShowDeleteConfirm = false">{{ $t('PlaceImageGallery.cancel') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <button class="menu-button" v-show="isShowActionButton" @click="test">
          <img class="menu-button" :src="util.getImagePath(`more_light_black@2x.png`)" :srcset="util.getImageSet(`more_light_black`)">
        </button> -->
    <div class="body">
      <div class="showing-image-list" @touchstart="touchStart" @touchend="touchEnd">
        <div class="showing-image" v-for="(image, index) in imageList" :key="`showing-${image.image_id}`" @click="isShowDetail = !isShowDetail" v-show="image.image_id === showingImageId">
          <div class="loading-image" v-show="image.isLoading && image.image_id === showingImageId">
            <div class="loading-animation"></div>
          </div>
          <img :src="image.imagepath" @load="loadedImage(index)" loading="lazy">
          <div class="detail" v-show="isShowDetail">
            <div class="description">{{ image.description }}</div>
            <div class="create">
              <div class="user">{{ image.owner_name }}</div>
              <div class="date">{{ util.getDateString(image.created, $root.$i18n.locale) }}</div>
            </div>
          </div>
        </div>

      </div>

      <button class="menu-button" v-show="isShowActionButton">
        <img class="menu-button" :src="util.getImagePath(`more_light_black@2x.png`)" :srcset="util.getImageSet(`more_light_black`)">
      </button>
      <div class="menu-panel" v-show="isShowMenuPanel" v-on-clickaway="closeMenu">
        <button @click="clickDeleteMenu">
          <img :src="util.getImagePath(`delete_light_black@2x.png`)" :srcset="util.getImageSet(`delete_light_black`)">
          <div>{{ $t('PlaceImageGallery.delete') }}</div>
        </button>
      </div>

      <div class="thumbnail-list">
        <div class="thumbnail" v-for="image in imageList" :ref="image.image_id" :key="image.image_id" :class="{focus: image.image_id === showingImageId}">
          <img @click="showingImageId = image.image_id" :src="`${image.imagepath}/120`" :srcset="`${image.imagepath}/120 1x, ${image.imagepath}/240 2x, ${image.imagepath}/360 3x, ${image.imagepath}/480 4x`" loading="lazy">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway'
import TitleBar from '@/components/TitleBar.vue'

export default {
  name: 'PlaceImageGallery',
  components: {
    TitleBar
  },
  directives: {
    onClickaway: onClickaway
  },
  props: {
    initialImageList: {
      type: Array,
      default: () => {
        return []
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isShowActionButton () {
      var self = this
      if (self.showingImageId) {
        var currentIndex = self.imageList.map(i => { return i.image_id }).indexOf(self.showingImageId)
        return currentIndex !== -1 ? self.imageList[currentIndex].permission.delete : false
      } else {
        return false
      }
    }
  },
  data () {
    return {
      imageList: [],
      isLoading: [],
      showingImageId: undefined,
      isLoadingIamge: true,
      startScreenX: 0,
      endScreenX: 0,
      isShowDetail: true,
      isShowMenuPanel: false,
      isDeleting: false,
      isShowDeleteConfirm: false
    }
  },
  mounted () {
    var self = this
    self.initialImageList.forEach((image) => {
      image.isLoading = true
      self.imageList.push(image)
    })
    // self.imageList.forEach((image) => {
    //   image.isLoading = true
    // })
    self.showingImageId = self.imageList[self.index].image_id
  },
  methods: {
    touchStart (e) {
      var self = this
      // console.log('touchStart')
      self.startScreenX = e.changedTouches[0].screenX
    },
    touchEnd (e) {
      var self = this
      // console.log('touchEnd')
      self.endScreenX = e.changedTouches[0].screenX
      var dif = self.endScreenX - self.startScreenX
      var currentIndex
      if (dif > 100 && dif < 500) {
        self.isShowDetail = true
        currentIndex = self.imageList.map(i => { return i.image_id }).indexOf(self.showingImageId)
        self.showingImageId = self.imageList[currentIndex === 0 ? self.imageList.length - 1 : currentIndex - 1].image_id
      } else if (dif < -100 && dif > -500) {
        self.isShowDetail = true
        currentIndex = self.imageList.map(i => { return i.image_id }).indexOf(self.showingImageId)
        self.showingImageId = self.imageList[currentIndex === self.imageList.length - 1 ? 0 : currentIndex + 1].image_id
      }
      self.$refs[`${self.showingImageId}`][0].scrollIntoView({
        behavior: 'auto',
        block: 'center',
        inline: 'center'
      })
    },
    clickCloseButton () {
      var self = this
      self.$router.back()
    },
    loadedImage (index) {
      var self = this
      self.imageList[index].isLoading = false
      self.$set(self.imageList, index, self.imageList[index])
      self.isShowDetail = true
    },
    closeMenu (e) {
      var self = this
      if (e.target.className.indexOf('menu-button') === -1) {
        if (self.isShowMenuPanel) {
          self.isShowDetail = true
        }
        self.isShowMenuPanel = false
      } else if (e.target.className.indexOf('menu-button') !== -1) {
        self.isShowMenuPanel = !self.isShowMenuPanel
        if (self.isShowMenuPanel) {
          self.isShowDetail = true
        }
      }
    },
    clickDeleteMenu () {
      var self = this
      self.isShowDeleteConfirm = true
      self.isShowMenuPanel = false
    },
    clickDelete () {
      var self = this
      self.isShowDeleteConfirm = false
      self.isShowMenuPanel = false
      if (self.isDeleting) {
        return
      }
      self.isDeleting = true
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      var currentIndex = self.imageList.map(i => { return i.image_id }).indexOf(self.showingImageId)
      self.pp.deletePromptpaiImage(
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        isAuthenticated ? undefined : uuid,
        self.imageList[currentIndex].image_id,
        undefined,
        (result) => {
          if (result.status.code === 200) {
            self.isDeleting = false
            window.gtag('event', 'delete', {'event_category': 'engagement', 'event_label': `delete_image_${self.imageList[currentIndex].image_id}`})
            self.$root.$emit('deleteImage', self.imageList[currentIndex].image_id)
            self.imageList.splice(currentIndex, 1)
            if (self.imageList.length > 0) {
              self.showingImageId = self.imageList[currentIndex >= self.imageList.length ? self.imageList.length - 1 : currentIndex].image_id
            } else {
              self.clickCloseButton()
            }
          } else if (result.status.code === 401) {
            self.isDeleting = false
            self.loginAgain()
          } else if (result.status.code === 403) {
            self.isDeleting = false
          } else {
            self.isDeleting = false
          }
        }
      )
    }
  },
  watch: {
    showingImageId () {
      var self = this
      self.$nextTick(() => {
        document.querySelector('.thumbnail.focus').scrollIntoView(true)
      })
    }
  }
}
</script>

<style scoped>
  .place-image-gallery {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
  }

  .backdrop {
    height: calc(100% - 50px);
    width: 100%;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 15;
  }

  .delete-confirm-container {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 15;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .delete-confirm {
    height: fit-content;
    width: calc(320px - 32px);
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.2);
  }

  .delete-confirm > .body {
    padding: 16px;
    background: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
  }

  .delete-confirm > .body > .text {
    margin: 16px 0px 24px 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    line-height: 1.75;
    text-align: center;
  }

  .delete-confirm > .body > .button-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .delete-confirm > .body > .button-container > button {
    width: calc((100% - 16px) / 2);
    padding: 6px;
    background: rgb(59, 144, 255);
    border-radius: 4px;
    border: none;
    color: rgb(255, 255, 255);
    margin: 0px;
    cursor: pointer;
    font-family: Prompt;
  }

  .delete-confirm > .body > .button-container > button.outline {
    background: rgb(255, 255, 255);
    border: 1px solid rgb(59, 144, 255);
    color: rgb(59, 144, 255);
  }

  .body {
    height: calc(100% - 50px);
    width: 100%;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, 0.95);
    display: flex;
    flex-direction: row;
  }

  .showing-image-list {
    width: calc(100% - 122px);
    height: 100%;
    position: relative;
  }

  .body > .menu-button {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    padding: 0px;
    border: none;
    cursor: pointer;
    z-index: 10;
    position: absolute;
    bottom: 0px;
    right: 122px;
  }

  .body > .menu-button > img {
    width: 24px;
    height: 24px;
  }

  .body > .menu-panel {
    z-index: 90;
    position: absolute;
    bottom: 44px;
    right: calc(122px + 12.5px);
    background-color: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.2);
    border-radius: 12.5px;
    overflow: hidden;
  }

  .body > .menu-panel > button {
    padding: 8px 16px;
    background-color: rgb(255, 255, 255);
    border: none;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
  }

  .body > .menu-panel > button > img {
    width: 24px;
    height: 24px;
    margin-right: 16px;
  }

  .body > .menu-panel > button > div {
    font-family: Prompt;
  }

  .showing-image {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    margin: 0px;
  }

  .showing-image > img {
    max-width: 100%;
    max-height: 100%;
  }

  .showing-image > .detail {
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 8px 50px 8px 8px;
    box-sizing: border-box;
    background-image: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
  }

  .showing-image > .detail > .description {
    line-height: 1.5;
    color: rgb(255, 255, 255);
    /* max-height: 100px; */
    overflow: hidden;
    /* overflow-y: auto; */
  }

  .showing-image > .detail > .description::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  .showing-image > .detail > .description::-webkit-scrollbar-thumb {
    background: rgb(251, 251, 251);
  }
  .showing-image > .detail > .description::-webkit-scrollbar {
    background-color: rgb(251, 251, 251);
  }
  .showing-image > .detail > .description::-webkit-scrollbar-thumb {
    border: 2px solid rgb(251, 251, 251);
  }

  .showing-image > .detail > .create {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    margin-top: 8px;
  }

  .showing-image > .detail > .create > .user {
    line-height: 1.5;
    color: rgb(255, 255, 255);
  }

  .showing-image > .detail > .create > .date {
    line-height: 1.5;
    color: rgb(255, 255, 255);
  }

  .loading-image {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(255, 255, 255);
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    margin: 0px;
  }

  .thumbnail-list {
    width: 122px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    white-space: unset;
  }

  .thumbnail-list::-webkit-scrollbar-button {
    height: 12.5px;
  }
  .thumbnail-list::-webkit-scrollbar {
    background-color: rgba(0, 0, 0, 0.9);
  }
  .thumbnail-list::-webkit-scrollbar-thumb {
    border: 2px solid rgba(0, 0, 0, 0.9);
  }

  .thumbnail {
    width: 120px;
    height: 120px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    border: 1px solid rgb(0, 0, 0);
  }

  .thumbnail.focus {
    border: 1px solid rgb(255, 255, 255);
  }

  .thumbnail > img {
    width: 118px;
    height: 118px;
    object-fit: cover;
    display: block;
  }

  @media only screen and (max-width: 768px) {
    .body {
      flex-direction: column;
    }

    .showing-image-list {
      width: 100%;
      height: calc(100% - 122px);
      position: relative;
    }

    .body > .menu-button {
      bottom: 122px;
      right: 0px;
    }

    .body > .menu-panel {
      bottom: calc(122px + 44px);
      right: 12.5px;
    }

    .thumbnail-list {
      width: 100%;
      height: 122px;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
    }

    .thumbnail {
      display: inline-block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PlaceImageGallery.vue